import { render, staticRenderFns } from "./addLink.vue?vue&type=template&id=37a24c26&scoped=true&"
import script from "./addLink.vue?vue&type=script&lang=js&"
export * from "./addLink.vue?vue&type=script&lang=js&"
import style0 from "./addLink.vue?vue&type=style&index=0&id=37a24c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a24c26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a24c26')) {
      api.createRecord('37a24c26', component.options)
    } else {
      api.reload('37a24c26', component.options)
    }
    module.hot.accept("./addLink.vue?vue&type=template&id=37a24c26&scoped=true&", function () {
      api.rerender('37a24c26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dynamic/communityDynamic/communityDynamicHome/components/addLink.vue"
export default component.exports